import React from 'react'
import { Grid, Segment, Button, Input, Form , Popup, Select} from 'semantic-ui-react'
import { BaseURLDev } from '../../_utils/config';
import bg from '../../login.jpg'
import swal from 'sweetalert';
// var jwt = require('jsonwebtoken');
   //function generateToken(user) {
  //1. Dont use password and other sensitive fields
  //2. Use fields that are useful in other parts of the     
  /*app/collections/models
  var u = {
   name: user.name,
   username: user.username,
   admin: user.admin,
   _id: user._id.toString(),
   image: user.image
  };  return token = jwt.sign(u, process.env.JWT_SECRET, {
     expiresIn: 60 * 60 * 24 // expires in 24 hours
  });
}*/

class LoginForm extends React.Component{
   constructor(){
      super();
      this.state = {
         data:{
            username:null,
            password:null,
            tahun: null
         },
         error:false,
         loading:false,
         show:false
      }
      this.onSubmit = this.onSubmit.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onChangeTahun= this.onChangeTahun.bind(this);

   }
   

   onSubmit(e){      
      if(this.state.data.password===null || this.state.data.username===null){
         swal("warning", "Username dan password harus diisi", "warning");
      }else{
         this.setState({loading:true});
         e.preventDefault();
         fetch(`${BaseURLDev}/login`,{
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state.data)
         })
         .then(response => {
            if (!response.ok) { 
               swal('User/password salah atau akun anda sudah tidak aktif',  { icon:'error' })
               this.setState({loading:false});
               return Promise.reject(response.statusText);
            }
            return response.json();
         })
         .then(user => {
            if(user.data===null){
               swal("Warning", `${user.messages}`, "warning");
               this.setState({loading: false})
            }
            else
            { 
               if(user.data) {
                  sessionStorage.setItem('data', JSON.stringify({
                     user: user.data,
                     skpd: [],
                     opd: [],
                  }));
                  setTimeout(() => {
                     this.setState({
                        loading: false,
                     })
                     window.location.href = '/';
                  }, 400)
               }
            }
         })
      }
   }

   getDataSKPD(){
      fetch(`${BaseURLDev}/simantra/ref/allskpd`)
      .then(response => {
         if(!response.ok){
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {this.seState({skpd:resJSON.data})})
   }

   getDataOPD(){
      fetch(`${BaseURLDev}/simantra/ref/allopd`)
      .then(response => {
         if(!response.ok){
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {this.seState({opd:resJSON.data})})
   }

   onChange(e){
      this.setState({
         data:{...this.state.data, [e.target.name]:e.target.value}
      })
   }

   componentDidMount(){
      this.username.focus();
   }

   onChangeTahun(e, el){
      this.setState({
         data: {
            ...this.state.data, tahun: el.value
         }
      })
   }
   render(){

      var datetime = new Date();
      var tahun = datetime.getFullYear();
      var opt_tahun = [];
      var key = 0;
      for(let i=2019; i<=tahun; i++){
         key += 1;
         opt_tahun.push(
            {'key': key, 'text': i.toString(), 'value': i},
         )
      }
      
      return(
         <div style={{backgroundImage:bg}}>
         <Grid id="login">
            <Grid.Column width={12}>
            </Grid.Column>            
            <Grid.Column width={4}>
               
               <Segment color="red" style={{marginTop:'15px'}}>
                  <Form loading={this.state.loading} onSubmit={this.onSubmit}>
                     <Form.Field>
                        <label>Username</label>
                        <Input 
                           required
                           ref={(input) => { this.username = input; }}
                           placeholder='Username' 
                           name="username" 
                           onChange={this.onChange}
                           autoComplete="off"
                           icon="user"
                        />
                     </Form.Field>
                     <Form.Field>
                      <label>Password</label>
                        <Input 
                           autoComplete="off"
                           required
                           placeholder='Password' 
                           name="password" 
                           type="password"
                           onChange={this.onChange}
                           icon="lock"
                        />
                     </Form.Field>
                     <label>Tahun Anggaran</label>
                     <Popup
                        trigger={
                           <Form.Field search control={Select}
                           required
                           onChange={this.onChangeTahun} 
                           options={opt_tahun} name="tahun" 
                           placeholder='Pilih tahun anggaran' />}
                        content='Pilih tahun anggaran'
                        on='hover'
                        inverted
                     />
                     <Button 
                        disabled={this.state.loading} 
                        color="violet" 
                        fluid
                        type='submit'>Login</Button>
                  </Form>
               </Segment>
            </Grid.Column>
         </Grid>
         </div>
      )
   }
}

export default LoginForm;


// WEBPACK FOOTER //
// ./src/components/Content/LoginForm.js